import { createServerFn } from "@tanstack/react-start";
import { logError, logInfo } from "@/lib/structured-log";
import type { CampaignDealResponse } from "@/lib/api/generated";
import { getDealInfoApiWorkspacesWorkspaceIdCampaignsCampaignIdDealsDealIdGet } from "@/lib/api/generated/campaigns/campaigns";

export const getDealInfoServer = createServerFn({ method: "GET" })
  .validator((data: { workspaceId: string; campaignId: string; dealId: string }) => data)
  .handler(async ({ data }): Promise<CampaignDealResponse> => {
    logInfo("deals.info.get.started", {
      workspace_id: data.workspaceId,
      campaign_id: data.campaignId,
      deal_id: data.dealId,
    });

    try {
      const response = await getDealInfoApiWorkspacesWorkspaceIdCampaignsCampaignIdDealsDealIdGet(
        data.workspaceId,
        data.campaignId,
        data.dealId,
      );

      if (response.status !== 200) {
        logError("deals.info.get.failed", {
          status: response.status,
          workspace_id: data.workspaceId,
          campaign_id: data.campaignId,
          deal_id: data.dealId,
        });
        throw new Error(`Failed to get deal info: ${response.status}`);
      }

      logInfo("deals.info.get.completed", { deal_id: response.data.id });
      return response.data;
    } catch (error) {
      logError("deals.info.get.error", {
        error: error instanceof Error ? error.message : "unknown-error",
        workspace_id: data.workspaceId,
        campaign_id: data.campaignId,
        deal_id: data.dealId,
      });
      throw error;
    }
  });
